<template>
  <span :class="['emd-tag', classList]">
    {{ text }}
    <i class="uil uil-times-circle" transform="width-16" @click="$emit('remove')"></i>
  </span>
</template>

<script>
export default {
  name: 'EmdTag',
  props: {
    text: {
      type: String,
      default: null,
      required: false
    },
    rounded: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    position: {
      type: String,
      default: null,
      required: false,
      validator: (value) => {
        return ['right', null].indexOf(value) !== -1
      }
    },
    color: {
      type: String,
      required: false,
      default: null,
      validator: (value) => {
        return ['primary', 'secondary', 'tertiary', 'success', 'danger', 'info', 'warning', 'subtle', null].indexOf(value) !== -1
      }
    }
  },
  computed: {
    classList () {
      var classList = []
      if (this.disabled) {
        classList.push('_disabled')
      }
      if (this.rounded) {
        classList.push('_rounded')
      }
      if (this.color) {
        classList.push(`_color_${this.color}`)
      }
      if (this.position) {
        classList.push(`_position_${this.position}`)
      }
      return classList
    }
  }
}
</script>
